export const IMAGE = 'IMAGE';
export const SIGNATURE = 'SIGNATURE';
export const INPUT_DATE = 'INPUT_DATE';
export const SELECT = 'SELECT';
